<template>
    <div class="header md-primary clear" id="pc-nav-header">
        <div class="nav-inner clear">
            <div class="nav-logo"><img @click="toPage(namespace.PAGE.HOME.id)" src="../../assets/logo-long.png"/></div>
            <div class="nav-menu">
                <div class="nav-menu-item"
                     v-for="(w, idx) in this.namespace.PAGE.ORDERED"
                     :key="idx" :class="'nav-item-' + w.id"
                     @click="toPage(w.id)">{{$t(w.navI18n)}}</div>


<!--                <md-menu class="nav-menu-item nav-lang md-disabled" md-size="medium" md-align-trigger>-->
<!--                    <div md-menu-trigger>-->
<!--                        <span>{{lang}}</span>-->
<!--                        <img v-if="'EN' === lang" class="icon" src="../../assets/lang-en.png">-->
<!--                        <img v-else class="icon" src="../../assets/lang-zh.png">-->
<!--                    </div>-->

<!--                    <md-menu-content class="help-menu-content">-->
<!--                        <md-menu-item @click="changeLang('zh')"><span class="help-text"><img src="../../assets/lang-zh.png" class="icon">ZH</span></md-menu-item>-->
<!--                        <md-menu-item @click="changeLang('en')"><span class="help-text"><img src="../../assets/lang-en.png" class="icon">EN</span></md-menu-item>-->
<!--                    </md-menu-content>-->
<!--                </md-menu>-->
            </div>
        </div>
    </div>
</template>

<script>
  import {toPage, changeLang, lang} from "../../js/common"
  import {scNamespace} from "../../js/scNamespace"

  export default {
    name: "nav-header",
    data() {
      return {
        namespace: scNamespace
      }
    },
    computed: {
      lang: lang,
    },
    methods: {
      toPage: toPage,
      changeLang: changeLang,
    }
  }
</script>

<style scoped>
    @media screen and (max-width: 959px){
        .header {
            display: none;
        }
    }

    #pc-nav-header {
        transition: all 0.6s;
    }
    #pc-nav-header.odd {
        background-color: #fff;
    }
    #pc-nav-header.even {
        background-color: #eff4f7;
    }
    .md-primary {
        width: 100%;
        height: 96px;
        z-index: 20000;
    }

    .nav-inner {
        width: 100%;
        max-width: 1280px;
        margin: 0 auto;
    }

    .nav-inner .nav-logo {
        float: left;
        height: 96px;
        line-height: 96px;
        padding-left: 40px;
    }

    .nav-inner .nav-logo > img {
        height: 36px;
        opacity: 1;
        margin-top: 0px;
        cursor: pointer;
        transition: all 1s;
    }

    .nav-inner .nav-logo.hide > img {
        opacity: 0;
        margin-top: 40px;
    }

    .nav-inner > .nav-menu {
        float: right;
    }

    .nav-inner > .nav-menu > .nav-menu-item {
        position: relative;
        font-size: 12px;
        float: left;
        margin: 0 20px;
        cursor: pointer;
        height: 24px;
        margin-top: 40px;
        color: #161920;
        transition: all 0.4s;
        text-transform: uppercase;
    }

    .nav-inner > .nav-menu > .nav-menu-item.nav-menu-item-selected,
    .nav-inner > .nav-menu > .nav-menu-item:hover {
        color: #ba2713;
    }

    .nav-inner > .nav-menu > .nav-menu-item:after {
        content: ' ';
        display: block;
        position: absolute;
        left: 50%;
        bottom: 0;
        width: 0;
        height: 2px;
        background-color: #ba2713;
        transition: all 0.3s;
    }

    .nav-inner > .nav-menu .nav-menu-item.nav-lang {
        margin-top: 38px;
    }

    .nav-inner > .nav-menu .nav-menu-item.nav-lang:hover:after {
        width: 0;
        vertical-align: middle;
    }

    .nav-inner > .nav-menu .nav-menu-item.nav-lang span {
        display: inline-block;
        margin-top: 2px;
    }

    .nav-inner > .nav-menu .nav-menu-item.nav-lang img.icon {
        width: 16px;
        margin-left: 4px;
        margin-top: -4px;
    }


    .nav-inner > .nav-menu > .nav-menu-item.nav-menu-item-selected:after,
    .nav-inner > .nav-menu > .nav-menu-item:hover:after {
        width: 100%;
        left: 0;
    }

    .logo > img {
        width: 100px;
    }

    .help-menu-content span.help-text {
        font-size: 12px;
    }
    .help-menu-content img.icon {
        width: 14px;
        margin: 0 6px;
        margin-top: -4px;
    }
</style>